// extracted by mini-css-extract-plugin
module.exports = {"container":"pinned-events_container__95LOB","mainEvent":"pinned-events_mainEvent__qcirv","secondEvent":"pinned-events_secondEvent__FVPBU"};